import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useQualificationStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.QUALIFICATION}/states/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useSkauTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.QUALIFICATION}/skau-types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
